import { Form, message } from 'antd';
import { useEffect, useState } from 'react';
// import {
//   actionGeneralInfo,
//   actionGetListBank,
// } from '../features/system/actions';
import {
  createCampaign,
  getCampaign,
  getListDomain,
  updateCampaign,
} from '../features/dashboard/actions';
import { isEmpty } from '../utils/helpers/helpers';

function useBanner(props) {
  const [url, setUrl] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [listBanner, setListBanner] = useState([]);
  const [bannerSelected, setBannerSelected] = useState({});
  const [aff_cid, setAff_cid] = useState('');
  const [form] = Form.useForm();
  const [listDomain, setListDomain] = useState([]);
  useEffect(() => {
    fetListDomain();
    // eslint-disable-next-line
  }, []);
  const fetListDomain = async () => {
    try {
      const { data } = await getListDomain();
      if (data.code === 200) {
        setListDomain(data?.data?.items || []);
        const location = props?.location || {};
        if (!isEmpty(data?.data?.items) && isEmpty(location.search)) {
          form.setFieldsValue({
            affiliationDomainId: data?.data?.items[0].id,
          });
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    const affiliationBanners = props?.generalInfo?.affiliationBanners || [];
    const location = props?.location || {};
    if (!isEmpty(location.search)) {
      const search = location.search;
      const params = new URLSearchParams(search);
      const aff_cid = params.get('aff_cid');
      if (!isEmpty(aff_cid)) {
        handleFetCampaignDetail(aff_cid, affiliationBanners);
      } else {
        setBannerFirst(affiliationBanners);
      }
    } else {
      setBannerFirst(affiliationBanners);
    }
    // eslint-disable-next-line
  }, [props.generalInfo]);

  const handleFetCampaignDetail = async (aff_cid, affiliationBanners = []) => {
    const { data } = await getCampaign(aff_cid);
    if (data.code === 200) {
      const dataRes = data?.data || {};
      const bannersSize = affiliationBanners.find(
        (el) => el.size === dataRes?.banner?.size
      );
      setListBanner(bannersSize?.banners || []);
      setAff_cid(aff_cid);
      setIsEdit(true);
      setUrl(dataRes?.sharingContent);
      setBannerSelected(dataRes?.banner);
      form.setFieldsValue({
        campaignName: dataRes.name || '',
        bannerSize: dataRes?.banner?.size,
        affiliationDomainId: dataRes.affiliationDomainId || '',
        specificLink: dataRes.specificLink || '',
        isCheckSpecificLink: !isEmpty(dataRes.specificLink),
      });
    }
  };

  const setBannerFirst = (affiliationBanners) => {
    if (!isEmpty(affiliationBanners)) {
      let bannerSelected = affiliationBanners[0];
      const bannerFind250 =
        affiliationBanners.find((el) => el.size === '250 x 250') || {};
      if (!isEmpty(bannerFind250)) {
        bannerSelected = bannerFind250;
      }
      form.setFieldsValue({
        bannerSize: bannerSelected.size || '',
      });
      const banners = bannerSelected?.banners || [];
      setListBanner(banners || []);
      if (!isEmpty(banners)) {
        setBannerSelected(banners[0]);
      }
    }
  };

  const onFinish = async (values) => {
    try {
      let dataDTO = {
        affiliationType: 'banner',
        campaignName: values.campaignName,
        bannerId: bannerSelected.id,
        affiliationDomainId: values.affiliationDomainId,
      };
      if (
        listDomain.find((el) => el.id === values.affiliationDomainId)
          ?.allowSpecificLink
      ) {
        if (values.isCheckSpecificLink) {
          dataDTO = { ...dataDTO, specificLink: values.specificLink };
        }
      }
      if (isEdit) {
        dataDTO = {
          ...dataDTO,
          id: aff_cid,
        };
      }
      let dataRes = {};
      if (isEdit) {
        const { data } = await updateCampaign(dataDTO);
        dataRes = data;
      } else {
        const { data } = await createCampaign(dataDTO);
        dataRes = data;
      }
      if (dataRes.code === 200) {
        setUrl(dataRes.data.sharingContent);
        message.success(
          `${isEdit ? 'Chỉnh sửa' : 'Tạo mới'} campaign thành công!`
        );
      } else {
        message.error('Đã có lỗi xảy ra vui lòng thử lại sau');
      }
    } catch (error) {}
  };

  const onFinishFailed = (errorInfo) => {};

  const onBannerChange = (value = '') => {
    setUrl('');
    const affiliationBanners = props?.generalInfo?.affiliationBanners || [];
    if (!isEmpty(affiliationBanners)) {
      const bannerSeizeSelect = affiliationBanners.find(
        (el) => el.size === value
      );
      if (!isEmpty(bannerSeizeSelect)) {
        const banners = bannerSeizeSelect?.banners || [];
        setListBanner(banners || []);
        if (!isEmpty(banners)) {
          setBannerSelected(banners[0]);
        }
      }
    }
  };

  const getSpan = (size = '120 x 600') => {
    switch (size) {
      case '728 x 90':
        return 24;
      case '468 x 80':
        return 12;
      case '300 x 250':
        return 8;
      default:
        return 6;
    }
  };
  return {
    getSpan,
    setUrl,
    url,
    isEdit,
    setIsEdit,
    setListBanner,
    listBanner,
    setBannerSelected,
    bannerSelected,
    setAff_cid,
    aff_cid,
    form,
    listDomain,
    onFinish,
    onFinishFailed,
    onBannerChange,
  };
}

export default useBanner;
